export default __webpack_public_path__ + "static/media/B35.fe3234b7.png";